import { withStyles } from '@material-ui/core/styles'

import theme from 'artkive/utils/theme'

import KeepsakeSection from './KeepsakeSection'

export const DisclaimerSection = withStyles({
  root: {
    paddingTop: 40,
    paddingBottom: 40,
    backgroundColor: theme.colors.sky[300],
    borderTop: `1px solid ${theme.colors.sky[400]}`,
    borderBottom: `1px solid ${theme.colors.sky[400]}`,
  },
})(KeepsakeSection)
